export default ({ $auth, redirect, app }) => {
  if (process.client) {
    const editorToken = localStorage.getItem('access_token')
    const editorExpiresAt = Date.parse(
      localStorage.getItem('oc_editor_expires_at') || ''
    )

    if (editorToken && editorToken.length > 10 && editorExpiresAt > Date.now()) {
      return
    }
  }

  if (!$auth.loggedIn) {
    return redirect(app.localePath('/sign-in'))
  }
}
